module.exports = __webpack_public_path__ + "static/media/confirm.223eaf41.svg";